const { m } = require('minthril');

function Image() {
  return {
    view: ({ attrs }) => {
      const { class: className = '', ...imageAttrs } = attrs;

      return m('img', {
        ...imageAttrs,
        class: `image ${className}`.trim()
      });
    }
  };
}

module.exports = { Image };
